import { TranslocoPipe } from '@jsverse/transloco';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ToastItem, ToastService } from '@core/toast';



@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [
        TranslocoPipe,CommonModule, MatIconModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent {
  @Input() toast!: ToastItem;
  constructor(private toastService: ToastService) {}
  dismiss() { this.toastService.dismiss(this.toast.id); }
}
